import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ScenariosFinderPageComponent } from './scenarios-finder-page/scenarios-finder-page.component';
import { ScenarioAuthGuard } from '@app/security/scenario-auth.guard';

const routes: Routes = [{ path: '', component: ScenariosFinderPageComponent, canActivate: [ScenarioAuthGuard] }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ScenarioRoutingModule {}
